(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-product-panel"] && !Shopify.designMode) return;
  try {
    (function() {
    var ENTRANCE_DELAY = 5000;

    /* ——— Delayed entrance ——— */
    function showPanels() {
      var panels = document.querySelectorAll('[data-article-panel]');
      panels.forEach(function(panel) {
        setTimeout(function() {
          panel.classList.add('article-panel--visible');
        }, ENTRANCE_DELAY);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showPanels);
    } else {
      showPanels();
    }

    /* ——— Toggle expand / collapse ——— */
    document.addEventListener('click', function(e) {
      var toggleEl = e.target.closest('[data-article-panel-toggle]');
      if (toggleEl) {
        var panel = toggleEl.closest('[data-article-panel]');
        if (!panel) return;
        var isExpanded = panel.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          collapsePanel(panel);
        } else {
          expandPanel(panel);
        }
        return;
      }

      /* ——— Close on backdrop ——— */
      var closeEl = e.target.closest('[data-article-panel-close]');
      if (closeEl) {
        var panel = closeEl.closest('[data-article-panel]');
        if (panel) collapsePanel(panel);
        return;
      }

      /* ——— Select quantity ——— */
      var option = e.target.closest('.article-panel__buy-option');
      if (option) {
        var panel = option.closest('[data-article-panel]');
        panel.querySelectorAll('.article-panel__buy-option').forEach(function(o) {
          o.classList.remove('article-panel__buy-option--selected');
        });
        option.classList.add('article-panel__buy-option--selected');
        var totalEl = panel.querySelector('[data-article-panel-total]');
        if (totalEl && option.dataset.panelPrice) {
          totalEl.textContent = option.dataset.panelPrice;
        }
        return;
      }

      /* ——— Add to cart ——— */
      var addBtn = e.target.closest('[data-article-panel-add]');
      if (addBtn) {
        var panel = addBtn.closest('[data-article-panel]');
        var selectedOption = panel.querySelector('.article-panel__buy-option--selected');
        if (!selectedOption) return;

        var variantId = selectedOption.dataset.panelVariantId;
        var qty = parseInt(selectedOption.dataset.panelQty, 10);
        var ctaText = addBtn.querySelector('[data-article-panel-cta-text]');
        var originalText = ctaText ? ctaText.textContent : '';

        addBtn.disabled = true;
        if (ctaText) ctaText.textContent = addBtn.dataset.textAdding || 'Ajout en cours\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          /* Success state */
          addBtn.classList.add('article-panel__cta--success');
          if (ctaText) ctaText.textContent = addBtn.dataset.textAdded || 'Ajout\u00e9 \u2713';

          /* Update cart count */
          return fetch('/cart.js');
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function(el) {
            el.textContent = cart.item_count;
            el.classList.toggle('header__cart-count--empty', cart.item_count === 0);
          });
          /* Auto-close after success */
          setTimeout(function() {
            collapsePanel(panel);
            addBtn.disabled = false;
            addBtn.classList.remove('article-panel__cta--success');
            if (ctaText) ctaText.textContent = originalText;
          }, 1500);
        })
        .catch(function() {
          addBtn.disabled = false;
          if (ctaText) ctaText.textContent = originalText;
        });
        return;
      }
    });

    /* ——— Close on Escape ——— */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var openPanel = document.querySelector('[data-article-panel][aria-expanded="true"]');
        if (openPanel) collapsePanel(openPanel);
      }
    });

    function expandPanel(panel) {
      panel.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function collapsePanel(panel) {
      panel.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      /* Scroll panel back to top for next open */
      var container = panel.querySelector('.article-panel__container');
      if (container) container.scrollTop = 0;
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-bubble"] && !Shopify.designMode) return;
  try {
    (function() {
  'use strict';

  var STORAGE_KEY = 'newsletter-bubble-dismissed';

  var root         = document.getElementById('newsletter-bubble');
  if (!root) return;

  var trigger      = root.querySelector('[data-newsletter-bubble-trigger]');
  var card         = document.getElementById('newsletter-bubble-card');
  var closeBtn     = root.querySelector('[data-newsletter-bubble-close]');
  var form         = root.querySelector('[data-newsletter-bubble-form]');
  var emailInput   = root.querySelector('[data-newsletter-bubble-input]');
  var submitBtn    = root.querySelector('[data-newsletter-bubble-submit]');
  var errorEl      = root.querySelector('[data-newsletter-bubble-error]');
  var defaultBody  = root.querySelector('[data-newsletter-bubble-default]');
  var successBody  = root.querySelector('[data-newsletter-bubble-success]');

  var delayMs      = (parseInt(root.getAttribute('data-trigger-delay'), 10) || 5) * 1000;

  // ── guard: already dismissed / subscribed ──
  if (localStorage.getItem(STORAGE_KEY)) return;

  // ── show the trigger after the configured delay ──
  setTimeout(function() {
    trigger.classList.add('is-visible');
    root.setAttribute('aria-hidden', 'false');
  }, delayMs);

  // ── toggle card open / close ──
  function openCard() {
    card.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    root.classList.add('newsletter-bubble--seen');
    emailInput.focus();
  }

  function closeCard() {
    card.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  trigger.addEventListener('click', function() {
    if (card.classList.contains('is-open')) {
      closeCard();
    } else {
      openCard();
    }
  });

  closeBtn.addEventListener('click', function() {
    closeCard();
  });

  // close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && card.classList.contains('is-open')) {
      closeCard();
      trigger.focus();
    }
  });

  // ── form submission via fetch ──
  form.addEventListener('submit', function(e) {
    e.preventDefault();

    var email = emailInput.value.trim();

    // basic client-side validation
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      emailInput.classList.add('is-invalid');
      errorEl.removeAttribute('hidden');
      emailInput.focus();
      return;
    }

    // clear previous state
    emailInput.classList.remove('is-invalid');
    errorEl.setAttribute('hidden', '');
    submitBtn.disabled = true;

    // build form body exactly as Shopify's customer form would
    var body = new URLSearchParams();
    body.append('contact[email]', email);
    body.append('contact[tags]', 'newsletter');

    fetch('/customers/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    }).then(function(response) {
      // Shopify returns 200 on success; treat anything else as an error
      if (!response.ok) throw new Error('subscription failed');

      // persist so bubble never reappears
      localStorage.setItem(STORAGE_KEY, '1');

      // swap default → success
      defaultBody.setAttribute('hidden', '');
      successBody.removeAttribute('hidden');
    }).catch(function() {
      // show inline error, re-enable submit
      errorEl.removeAttribute('hidden');
      submitBtn.disabled = false;
      emailInput.focus();
    });
  });

  // ── dismiss: hide the trigger entirely & persist ──
  closeBtn.addEventListener('click', function() {
    // only persist the dismissal when the card is in its *default* (non-success) state
    if (defaultBody.hasAttribute('hidden') === false) {
      localStorage.setItem(STORAGE_KEY, '1');
      trigger.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    // ——— Open sheet ———
    document.addEventListener('click', function(e) {
      const openBtn = e.target.closest('[data-open-buy-sheet]');
      if (openBtn) {
        e.preventDefault();
        const productId = openBtn.dataset.openBuySheet;
        const sheet = document.getElementById('buy-sheet-' + productId);
        if (sheet) {
          sheet.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          // Focus the close button for a11y
          const closeBtn = sheet.querySelector('.buy-sheet__close');
          if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 50);
        }
        return;
      }

      // ——— Close triggers ———
      const closeEl = e.target.closest('[data-buy-sheet-close]');
      if (closeEl) {
        const sheet = closeEl.closest('[data-buy-sheet]');
        if (sheet) closeSheet(sheet);
        return;
      }

      // ——— Select quantity option ———
      const option = e.target.closest('.buy-sheet__option');
      if (option) {
        const sheet = option.closest('[data-buy-sheet]');
        sheet.querySelectorAll('.buy-sheet__option').forEach(function(o) {
          o.classList.remove('buy-sheet__option--selected');
        });
        option.classList.add('buy-sheet__option--selected');
        // Update total price display
        const totalEl = sheet.querySelector('[data-buy-sheet-total]');
        if (totalEl && option.dataset.price) {
          totalEl.textContent = option.dataset.price;
        }
        return;
      }

      // ——— Add to cart ———
      const addBtn = e.target.closest('[data-buy-sheet-add]');
      if (addBtn) {
        const sheet = addBtn.closest('[data-buy-sheet]');
        const selectedOption = sheet.querySelector('.buy-sheet__option--selected');
        if (!selectedOption) return;

        const variantId = selectedOption.dataset.variantId;
        const qty = parseInt(selectedOption.dataset.qty, 10);
        const btnSpan = addBtn.querySelector('span');
        const originalText = btnSpan ? btnSpan.textContent : '';

        addBtn.disabled = true;
        if (btnSpan) btnSpan.textContent = 'Ajout en cours...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          closeSheet(sheet);
          return fetch('/cart.js');
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function(el) {
            el.textContent = cart.item_count;
            el.classList.toggle('header__cart-count--empty', cart.item_count === 0);
          });
        })
        .catch(function() {
          addBtn.disabled = false;
          if (btnSpan) btnSpan.textContent = originalText;
        });
        return;
      }
    });

    // ——— Close on Escape ———
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const openSheet = document.querySelector('[data-buy-sheet][aria-hidden="false"]');
        if (openSheet) closeSheet(openSheet);
      }
    });

    function closeSheet(sheet) {
      sheet.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    const dots = gallery.querySelectorAll('[data-gallery-dot]');
    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');
    const zoomContainer = gallery.querySelector('[data-gallery-zoom]');

    if (slides.length === 0) return;

    let currentIndex = 0;

    function showSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.hidden = i !== index;
      });

      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      currentIndex = index;

      // Scroll active thumbnail into view
      const activeThumb = thumbs[index];
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    // Thumbnail clicks
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => showSlide(i));
    });

    // Dot clicks
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => showSlide(i));
    });

    // Navigation arrows
    if (prevBtn) {
      prevBtn.addEventListener('click', () => showSlide(currentIndex - 1));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => showSlide(currentIndex + 1));
    }

    // Keyboard navigation
    gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        showSlide(currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        showSlide(currentIndex + 1);
      }
    });

    // Touch swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    const mainWrapper = gallery.querySelector('.product-gallery__main-wrapper');
    if (mainWrapper) {
      mainWrapper.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      mainWrapper.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            showSlide(currentIndex + 1);
          } else {
            showSlide(currentIndex - 1);
          }
        }
      }, { passive: true });
    }

    // Zoom functionality (mouse tracking)
    if (zoomContainer) {
      const mainWrapper = gallery.querySelector('.product-gallery__main-wrapper');
      const zoomImage = zoomContainer.querySelector('.product-gallery__zoom-image');

      if (mainWrapper && zoomImage) {
        mainWrapper.addEventListener('mousemove', (e) => {
          const rect = mainWrapper.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          zoomImage.style.transform = `translate(-${x}%, -${y}%)`;
        });
      }
    }

    // Variant change - switch to matching media
    document.addEventListener('variant:changed', (e) => {
      const variant = e.detail.variant;
      if (variant && variant.featured_media) {
        const mediaId = variant.featured_media.id;
        slides.forEach((slide, i) => {
          if (slide.dataset.mediaId == mediaId) {
            showSlide(i);
          }
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-quantity-selector]').forEach(selector => {
    const input = selector.querySelector('[data-quantity-input]');
    const minusBtn = selector.querySelector('[data-quantity-minus]');
    const plusBtn = selector.querySelector('[data-quantity-plus]');

    if (!input || !minusBtn || !plusBtn) return;

    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || 99;

    function updateButtons() {
      const value = parseInt(input.value) || min;
      minusBtn.disabled = value <= min;
      plusBtn.disabled = value >= max;
    }

    minusBtn.addEventListener('click', () => {
      const currentValue = parseInt(input.value) || min;
      if (currentValue > min) {
        input.value = currentValue - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        updateButtons();
      }
    });

    plusBtn.addEventListener('click', () => {
      const currentValue = parseInt(input.value) || min;
      if (currentValue < max) {
        input.value = currentValue + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        updateButtons();
      }
    });

    input.addEventListener('change', () => {
      let value = parseInt(input.value) || min;
      value = Math.max(min, Math.min(max, value));
      input.value = value;
      updateButtons();
    });

    input.addEventListener('blur', () => {
      if (!input.value || parseInt(input.value) < min) {
        input.value = min;
        updateButtons();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
